import React from 'react'

import AceEditor from "react-ace";

import "ace-builds/src-noconflict/mode-java";
import "ace-builds/src-noconflict/theme-github";

import { InView } from 'react-intersection-observer';

import Collapsible from 'react-collapsible';
import Border from '../Border'

import Section from './editable/Section'

import General from '../../utils/General'

import Titles from './editable/Titles';
import SafeHtml from "../SafeHtml";

import Block from "./Block";


export default class Block54 extends Block {
  constructor(props){
    super(props)

    this.state = {
      key: 0,
      data: props.data,
      editable: props.editable,
      uuid: "cb_"+General.uuid()
    }

    this.section = React.createRef();
  }

  componentWillReceiveProps(nextProps){
    this.setState(nextProps)
  }

  _update(data, callback){
    let {
      key
    } = this.state

    this.setState({ ...data }, () => {

      if(callback){
        callback()
      }
      this.updateContentBlock()
    })
  }

  _getModalContent(data){
    return (
      <>
        <Border>
          <Collapsible
            trigger="Code"
          >
            <br/>
            <span>Enter your custom HTML/CSS/JS here</span>
            <br/>
            <a
              href="https://help.checkoutchamp.com/funnel-builder/creating-and-editing-funnels-pages/funnel-visualizer-and-page-builder/storefront/customization/html-blocks-and-code-sections"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                fontSize: "12px",
                color: "#007bff",
                textDecoration: "underline",
                display: "inline-flex",
                alignItems: "center"
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                style={{ marginRight: "4px" }}
                className="lucide lucide-book-open"
              >
                <path d="M12 7v14" />
                <path d="M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z" />
              </svg>
              View Help Doc
            </a>
            <br/>
            <div
              style={{
                width: "100%",
                padding: 8,
                backgroundColor: "#f5f5f5"
              }}
            >
              <AceEditor
                mode="javascript"
                theme="xcode"
                style={{ width: "100%", backgroundColor: "transparent"}}
                defaultValue={data.body}
                showGutter={false}
                debounceChangePeriod={1000}
                onChange={body => {
                  data.body = body
                  this._update(data)
                }}
              />
            </div>
            <br/>
            <div class="row align-items-center">
              <div class="col-md-8">
                <h4 className='lh-1 mb-0'>Lazy Load<br></br><small className='fs-12 lh-1'>Only trigger code when section comes into view</small></h4>
              </div>
              <div class="col-md-4 text-right">
                <div class="input-checkbox input-checkbox--switch">
                  <input
                    id="custom_block_variation"
                    type="checkbox"
                    defaultChecked={data.variation}
                    onChange={(e) => {
                      if (e.target.checked) {
                        data.variation = "lazy_load"
                      } else {
                        data.variation = null
                      }
                      this._update(data);
                    }}
                  />
                  <label for="custom_block_variation"></label>
                </div>
              </div>
            </div>
          </Collapsible>
        </Border>
      </>
    )
  }


  render(){
    let { data, editable, uuid, key } = this.state
    return (
      <Section
          ref={this.section}
          data={ data }
          index={ this.props.index }
          className={ " block-54 text-center " + this.props.className }
          editable={ editable }
          onUpdated={data => this._update(data)}
          onDelete={() => this.props.onDelete()}
          primaryColor={false}
          secondaryColor={false}
          onAddContentBlockPressed={contentBlock => this.props.onAddContentBlockPressed(contentBlock)}
          renderModalContent={() => this._getModalContent(data)}
          canMoveUp={ this.props.canMoveUp }
          canMoveDown={ this.props.canMoveDown }
          onVisibilityButtonPressed={(index) => this.props.onVisibilityButtonPressed(index)}
          onMoveUpPressed={ () => this.props.onMoveUpPressed() }
          onMoveDownPressed={ () => this.props.onMoveDownPressed() }
          onVisibilityToggled={() => this.props.onVisibilityToggled()}
      >
        <div class="container" key={key}>

          <Titles
            data={ data }
            editable={ editable }
            onUpdated={data => this._update(data)}
            headingNumber={2}
          />

          {!data.variation && data.body &&
            <SafeHtml html={data.body}/>
          }
          {data.variation==="lazy_load" && data.body &&
            <InView
                triggerOnce={true}
              >
              {({ inView, ref, entry }) => (
                <div ref={ref}>
                  { inView &&
                    <SafeHtml html={data.body}/>
                  }
                </div>
              )}
            </InView>
          }
        </div>
      </Section>
    )
  }
}
